import { useParams, Link } from "react-router-dom";
import SignalLock from "@/pages/lander/variants/SignalLock";
import Console from "@/pages/lander/variants/Console";
import TrustGrid from "@/pages/lander/variants/TrustGrid";
import Vault from "@/pages/lander/variants/Vault";
import { LandingAddon } from "@/components/lander/LandingAddon";
import { LegalFooter } from "@/components/lander/LegalFooter";
import { DEFAULT_LANDER } from "@/config";
import { cn } from "@/lib/utils";

const MAP = { 1: SignalLock, 2: Console, 3: TrustGrid, 4: Vault };
const NAMES = { 1: "Signal Lock", 2: "Console", 3: "Trust Grid", 4: "Vault" };

function VariantSwitcher({ current }) {
  return (
    <div className="fixed bottom-4 left-1/2 z-50 flex -translate-x-1/2 items-center gap-1 rounded-full border border-white/12 bg-black/70 p-1.5 backdrop-blur-xl" data-testid="lander-switcher">
      <span className="px-2 text-[10px] font-bold uppercase tracking-widest text-bloq-muted">Preview</span>
      {[1, 2, 3, 4].map((v) => (
        <Link
          key={v}
          to={`/lander/${v}`}
          className={cn(
            "rounded-full px-3 py-1.5 text-xs font-semibold transition-colors",
            v === current ? "bloq-gradient text-bloq-bg" : "text-bloq-muted hover:text-white",
          )}
          data-testid={`switch-lander-${v}`}
        >
          {v}. {NAMES[v]}
        </Link>
      ))}
    </div>
  );
}

export default function ComingSoon({ variant, preview = false }) {
  const params = useParams();
  const v = variant || Number(params.variant) || DEFAULT_LANDER;
  const Variant = MAP[v] || SignalLock;
  return (
    <>
      <Variant />
      <LandingAddon />
      <LegalFooter />
      {preview && <VariantSwitcher current={v} />}
    </>
  );
}
